import { render, staticRenderFns } from "./SecurityTab.vue?vue&type=template&id=187a3e80"
import script from "./SecurityTab.vue?vue&type=script&lang=js"
export * from "./SecurityTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports